/**
 *
 * InitializeSiteTitle
 *
 */
import { useMenuSlice } from 'app/components/Menu/slice';
import * as React from 'react';
import { useDispatch } from 'react-redux';

export function useInitializeSiteTitle(title: string) {
  const {
    actions: { changeTitle },
  } = useMenuSlice();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(changeTitle({ siteTitle: title }));
  }, [dispatch, changeTitle, title]);

  return null;
}

export function useInitializeSiteTitleWithSuffix(
  title: string,
  suffix: string | undefined,
  delimiter = ' -- ',
) {
  const {
    actions: { changeTitle },
  } = useMenuSlice();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      changeTitle({
        siteTitle: `${title}${suffix ? delimiter + suffix : ''}`,
      }),
    );
  }, [dispatch, changeTitle, title, suffix, delimiter]);

  return null;
}
